const MASTER_ROLES = new Set(["master", "admin"]);
const MASTER_EMAILS = new Set(["nitfisio@nitfisio.com.br"]);

export const normalizeEmail = (value: string | null | undefined) =>
  value?.trim().toLowerCase() ?? "";

export const hasMasterRole = (value: string | null | undefined) =>
  MASTER_ROLES.has(value?.trim().toLowerCase() ?? "");

export const normalizeUserRole = (value: string | null | undefined): "master" | "user" =>
  hasMasterRole(value) ? "master" : "user";

export const isTrustedMasterEmail = (email: string | null | undefined) =>
  MASTER_EMAILS.has(normalizeEmail(email));

type ResolveMasterAccessInput = {
  profileRole?: string | null;
  fallbackProfileRole?: string | null;
  professionalType?: string | null;
  professionalRole?: string | null;
  metadataRole?: string | null;
  email?: string | null;
};

export const resolveMasterAccess = ({
  profileRole,
  fallbackProfileRole,
  professionalType,
  professionalRole,
  metadataRole,
  email,
}: ResolveMasterAccessInput) => {
  return (
    hasMasterRole(profileRole)
    || hasMasterRole(fallbackProfileRole)
    || hasMasterRole(professionalType)
    || hasMasterRole(professionalRole)
    || hasMasterRole(metadataRole)
    || isTrustedMasterEmail(email)
  );
};
